<template>
    <div>
        <div class="text-center mb-2">
            <h1 class="text-theme-primary text-3xl font-bold">
                Nuevo producto
            </h1>
            <p class="mt-2 text-theme-base max-w-2xl mx-auto text-sm">
                Elige cómo quieres crear el producto. La creación rápida es
                ideal para productos simples; la creación completa te permite
                configurar variantes, categoría, marca e inventario.
            </p>
        </div>

        <div class="container mx-auto mt-6">
            <div class="flex flex-wrap justify-center gap-6">
                <router-link
                    to="/app/products/new/fast"
                    class="text-decoration-none w-full sm:w-80"
                >
                    <div
                        class="button-card h-full bg-brand-blue rounded-xl p-5 shadow-sm text-white flex flex-col"
                    >
                        <div class="flex items-start gap-3 mb-3">
                            <span class="text-4xl leading-none">⚡</span>
                            <div>
                                <span
                                    class="inline-block text-xs font-semibold bg-white bg-opacity-20 text-white px-2 py-0.5 rounded-full mb-1"
                                >
                                    Rápida
                                </span>
                                <h5
                                    class="text-white font-semibold leading-tight"
                                >
                                    Creación rápida
                                </h5>
                            </div>
                        </div>

                        <p class="text-sm mb-3 opacity-90">
                            Solo nombre y precio. Ideal para agregar productos
                            al catálogo sin configuración adicional.
                        </p>

                        <hr class="mb-3 opacity-20" />

                        <ul
                            class="text-sm space-y-2 flex-1 list-none ps-0 opacity-90"
                        >
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span>Nombre y precio del producto</span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span>Fotos opcionales</span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">⏭</span>
                                <span>Sin variantes ni clasificación</span>
                            </li>
                        </ul>

                        <div
                            class="mt-4 text-center text-sm font-semibold text-white"
                        >
                            Ir a creación rápida →
                        </div>
                    </div>
                </router-link>

                <router-link
                    to="/app/products/new/complete"
                    class="text-decoration-none w-full sm:w-80"
                >
                    <div
                        class="button-card h-full bg-brand-purple rounded-xl p-5 shadow-sm text-white flex flex-col"
                    >
                        <div class="flex items-start gap-3 mb-3">
                            <span class="text-4xl leading-none">🛍️</span>
                            <div>
                                <span
                                    class="inline-block text-xs font-semibold bg-white bg-opacity-20 text-white px-2 py-0.5 rounded-full mb-1"
                                >
                                    Completa
                                </span>
                                <h5
                                    class="text-white font-semibold leading-tight"
                                >
                                    Creación completa
                                </h5>
                            </div>
                        </div>

                        <p class="text-sm mb-3 opacity-90">
                            Configura variantes, categoría, marca e inventario
                            inicial en un solo flujo guiado.
                        </p>

                        <hr class="mb-3 opacity-20" />

                        <ul
                            class="text-sm space-y-2 flex-1 list-none ps-0 opacity-90"
                        >
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span>Datos básicos y fotos</span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span
                                    >Variantes (talla, color,
                                    personalizado)</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span>Categoría y marca</span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span>Inventario inicial</span>
                            </li>
                        </ul>

                        <div
                            class="mt-4 text-center text-sm font-semibold text-white"
                        >
                            Ir a creación completa →
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductsNewSelector"
};
</script>
